import { useLocation, useNavigate } from "react-router-dom";
import DiscordIcon from "../../icon/DiscordIcon";
import HelpIcon from "../../icon/HelpIcon";
import LogoutIcon from "../../icon/LogoutIcon";
import classes from "./Header.module.css";
import CloseIcon from "../../icon/CloseIcon";
import { useUser } from "../../context/UserContext";
import SparklesIcon from "../../icon/SparklesIcon";
import useWindowDimensions from "../../hooks/getWindowDimensions";
import { IoMdClose } from "react-icons/io";
import { AiOutlineMenu } from "react-icons/ai"; // Menu icon
import { useState } from "react";
import UserCircleIcon from "../../icon/UserCircleIcon";
import { toast } from "react-toastify";
import EditIcon from "../../icon/EditIcon";
import FileIcon from "../../icon/FileIcon";
import HelpSqaureIcon from "../../icon/HelpSquareIcon";

const whitelist = [
  "stevegathecha876@gmail.com",
  "Shadrackwaltha@gmail.com",
  "benjaminaderopo@gmail.com",
  "ikyorsam@gmail.com",
  "Forexbusinessjune2020@gmail.com",
  "Mulengaklein@gmail.com",
  "kleinmulenga@yahoo.com",
  "jose@primebridge.io",
  "shaun.opoku0431@gmail.com",
  "shauntesting1@gmail.com",
  "rebateboard@gmail.com",
  "Camrin@team-pow.com",
  "tongphuong8899@gmail.com",
  "Agbemaflec918@gmail.com"
];

const Header = ({ faq }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showUserPopup, setShowUserPopup] = useState(false);

  const { height, width } = useWindowDimensions();
  const { logout, user, updateUserName } = useUser();

  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(user?.name || "");
  // Close menu when clicking outside
  const closeMenu = (e) => {
    if (e.target.classList.contains(classes.menuOverlay)) {
      setMenuOpen(false);
    }
  };

  const handleSave = async () => {
    const res = await updateUserName(editedName);

    if (res.success) {
      console.log("Name updated:", editedName);
      setIsEditing(false);
    } else {
      console.error("Failed to update name:", res.error);
      toast.error("Failed to update name:", res.error);
      setIsEditing(false);
      // optionally show an error message
    }
  };
  return (
    <>
      <div
        className={`${classes.wrapper} d-flex justify-content-between align-items-center`}
      >
        <img
          src="/PROPTRADING.FUN-LOGO.svg"
          alt="logo"
          onClick={() => navigate("/")}
          role="button"
        />

        {width > 768 && !faq && (
          <div
            className={`d-flex align-items-center gap-4 ${classes.navLinks}`}
          >
            <span
              className={
                location.pathname === "/trading" ? classes.activeLink : ""
              }
              onClick={() => navigate("/trading")}
              role="button"
            >
              Trading
            </span>
            <span
              className={
                location.pathname === "/data-engine" ? classes.activeLink : ""
              }
              onClick={() => navigate("/data-engine")}
              role="button"
            >
              Data Engine
            </span>
            <span
              className={
                location.pathname === "/leaderboard" ? classes.activeLink : ""
              }
              onClick={() => navigate("/leaderboard")}
              role="button"
            >
              Leaderboard
            </span>
            <span
              className={
                location.pathname === "/stats" ? classes.activeLink : ""
              }
              onClick={() => navigate("/stats")}
              role="button"
            >
              Stats
            </span>
            {/* <span
              className={
                location.pathname === "/arena" ? classes.activeLink : ""
              }
              onClick={() => navigate("/arena")}
              role="button"
            >
              Arena
            </span> */}
            {whitelist.map(email => email.toLowerCase()).includes(user?.email?.toLowerCase()) && (
              <span
                className={
                  location.pathname === "/refer" ? classes.activeLink : ""
                }
                onClick={() => navigate("/refer")}
                role="button"
              >
                Refer & Earn
              </span>
            )}
          </div>
        )}
        {faq ? (
          <CloseIcon onClick={() => navigate("/")} />
        ) : (
          <div className="d-flex align-items-center position-relative gap-3">
            {showUserPopup && (
              <div className={classes.userCard}>
                <div
                  className={`d-flex align-items-center gap-2 ${classes.userInfo}`}
                >
                  <UserCircleIcon size={40} color="white" />
                  <div>
                    <div className={classes.userName}>
                      {isEditing ? (
                        <input
                          type="text"
                          value={editedName}
                          onChange={(e) => setEditedName(e.target.value)}
                          onBlur={handleSave}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleSave();
                            }
                          }}
                          autoFocus
                          className={classes.editInput}
                        />
                      ) : (
                        <>
                          {user?.name}{" "}
                          <span
                            role="button"
                            onClick={() => setIsEditing(true)}
                          >
                            <EditIcon />
                          </span>
                        </>
                      )}
                    </div>
                    <div className={classes.userEmail}>{user?.email}</div>
                  </div>
                </div>
                <div className={classes.dropdownDivider} />
                <a href="https://docs.propfunding.com" target="_blank">
                  <button
                    className={`d-flex align-items-center gap-2 ${classes.dropdownItem}`}
                  >
                    <FileIcon /> Docs
                  </button>
                </a>
                <div className={classes.dropdownDivider} />
                <button
                  className={`d-flex align-items-center gap-2 ${classes.dropdownItem}`}
                  onClick={() => {
                    navigate("/faq");
                    setShowUserPopup(false);
                  }}
                >
                  <HelpSqaureIcon />
                  FAQ
                </button>
              </div>
            )}
            {width > 768 ? (
              <>
                {/* <a href="https://docs.propfunding.com" target="_blank">
                  <button>Docs</button>
                </a>

                <button onClick={() => navigate("/faq")}>FAQs</button> */}

                <div className="d-flex align-items-center gap-2">
                  <UserCircleIcon
                    onClick={() => setShowUserPopup(!showUserPopup)}
                  />
                  <DiscordIcon />
                  <LogoutIcon onClick={logout} />
                </div>
              </>
            ) : (
              <div className="d-flex align-items-center gap-3">
                <UserCircleIcon
                  onClick={() => setShowUserPopup(!showUserPopup)}
                  color="white"
                />
                <div
                  className="menu-icon"
                  onClick={() => setMenuOpen(!menuOpen)}
                >
                  {menuOpen ? (
                    <IoMdClose size={24} />
                  ) : (
                    <div className={classes.twoBarMenu}></div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      {/* Full-screen overlay (visible when menu is open) */}
      {menuOpen && (
        <div className={classes.menuOverlay} onClick={closeMenu}>
          <div
            className={`d-flex justify-content-between align-items-center w-100 ${classes.mobileHeader}`}
          >
            <img
              src="/PROPTRADING.FUN-LOGO.svg"
              alt="logo"
              onClick={() => navigate("/")}
              role="button"
            />
            <div className="menu-icon" onClick={() => setMenuOpen(false)}>
              <IoMdClose size={24} />{" "}
            </div>
          </div>
          <div className={`d-flex flex-column  ${classes.mobileMenu}`}>
            <span
              className={
                location.pathname === "/trading" ? classes.activeLink : ""
              }
              onClick={() => {
                navigate("/trading");
                setMenuOpen(false);
              }}
              role="button"
            >
              Trading
            </span>
            <span
              className={
                location.pathname === "/data-engine" ? classes.activeLink : ""
              }
              onClick={() => {
                navigate("/data-engine");
                setMenuOpen(false);
              }}
              role="button"
            >
              Data Engine
            </span>
            <span
              className={
                location.pathname === "/leaderboard" ? classes.activeLink : ""
              }
              onClick={() => {
                navigate("/leaderboard");
                setMenuOpen(false);
              }}
              role="button"
            >
              Leaderboard
            </span>

            <span
              className={
                location.pathname === "/stats" ? classes.activeLink : ""
              }
              onClick={() => {
                navigate("/stats");
                setMenuOpen(false);
              }}
              role="button"
            >
              Stats
            </span>
            {/* <span
              className={
                location.pathname === "/arena" ? classes.activeLink : ""
              }
              onClick={() => {
                navigate("/arena");
                setMenuOpen(false);
              }}
              role="button"
            >
              Arena
            </span> */}
            {whitelist.map(email => email.toLowerCase()).includes(user?.email?.toLowerCase()) && (
              <span
                className={
                  location.pathname === "/refer" ? classes.activeLink : ""
                }
                onClick={() => {
                  navigate("/refer");
                  setMenuOpen(false);
                }}
                role="button"
              >
                Refer & Earn
              </span>
            )}

            <a
              href="https://discord.gg/8z37khrMA6"
              target="_blank"
              rel="noopener noreferrer"
              className={`text-decoration-none ${classes.link}`}
            >
              Join Discord
            </a>
            <a
              href="https://www.instagram.com/getpropfunding?igsh=dmg2NTBxN2hiZDNl"
              target="_blank"
              rel="noopener noreferrer"
              className={`text-decoration-none ${classes.link}`}
            >
              Follow on Instagram
            </a>
            <div
              onClick={logout}
              className={`text-decoration-none ${classes.link} ${classes.buttonLink}`}
            >
              Logout
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
